import * as fragments from './fragments';

export const cartGet = `
  query cart(
    $id: ID!,
    $countryCode: CountryCode!,
    $languageCode: LanguageCode!
  )
  @inContext(
    country: $countryCode,
    language: $languageCode
  ) {
    cart(id: $id) {
      ${fragments.cart}
    }
  }
`;

export const cartCreate = `
  mutation cartCreate(
    $input: CartInput!,
    $countryCode: CountryCode!,
    $languageCode: LanguageCode!
  )
  @inContext(
    country: $countryCode,
    language: $languageCode
  ) {
    cartCreate(input: $input) {
      cart {
        id
      }
      userErrors {
        field
        message
      }
    }
  }
`;

export const cartLinesAdd = `
  mutation cartLinesAdd(
    $cartId: ID!,
    $lines: [CartLineInput!]!,
    $countryCode: CountryCode!,
    $languageCode: LanguageCode!
  )
  @inContext(
    country: $countryCode,
    language: $languageCode
  ) {
    cartLinesAdd(cartId: $cartId, lines: $lines) {
      cart {
        ${fragments.cart}
      }
      userErrors {
        field
        message
      }
    }
  }
`;

export const cartLinesRemove = `
  mutation cartLinesRemove(
    $cartId: ID!,
    $lineIds: [ID!]!
    $countryCode: CountryCode!,
    $languageCode: LanguageCode!
  )
  @inContext(
    country: $countryCode,
    language: $languageCode
  ) {
    cartLinesRemove(cartId: $cartId, lineIds: $lineIds) {
      cart {
        ${fragments.cart}
      }
      userErrors {
        field
        message
      }
    }
  }
`;

export const cartLinesUpdate = `
  mutation cartLinesUpdate(
    $cartId: ID!,
    $lines: [CartLineUpdateInput!]!
    $countryCode: CountryCode!,
    $languageCode: LanguageCode!
  )
  @inContext(
    country: $countryCode,
    language: $languageCode
  ) {
    cartLinesUpdate(cartId: $cartId, lines: $lines) {
      cart {
        ${fragments.cart}
      }
      userErrors {
        field
        message
      }
    }
  }
`;

export const collectionGet = `
  query collectionGet(
    $id: ID!,
    $first: Int!,
    $countryCode: CountryCode!,
    $languageCode: LanguageCode!
  )
  @inContext(
    country: $countryCode,
    language: $languageCode
  ) {
    collection(id: $id) {
      products(first: $first) {
        edges {
          node {
            ${fragments.product}
          }
        }
      }
    }
  }
`;

export const productByHandle = () => `
  query product(
    $handle: String!,
    $countryCode: CountryCode!,
    $languageCode: LanguageCode!
  )
  @inContext(
    country: $countryCode,
    language: $languageCode
  ) {
    productByHandle(handle: $handle) {
      ${fragments.product}
    }
  }
`;

export const productsByTag = (tag, first) => `
  query productsByTag (
    $countryCode: CountryCode!,
    $languageCode: LanguageCode!
  )
  @inContext(
    country: $countryCode,
    language: $languageCode
  ) {
    products(query: "tag:'${tag}'", first: ${first}) {
      nodes {
        ...on Product {
          ${fragments.product}
        }
      }
    }
  }
`;

export const collectionById = `
  query collectionById (
    $id: ID!,
    $countryCode: CountryCode!,
    $languageCode: LanguageCode!,
    $first: Int!
  )
  @inContext(
    country: $countryCode,
    language: $languageCode
  ) {
    node(id: $id) {
      ...on Collection {
        title
        descriptionHtml
        products(first: $first) {
          edges {
            node {
              ${fragments.product}
            }
          }
        }
      }
    }
  }
`;

export const megaMenuMetaobjects = `
  query (
    $countryCode: CountryCode!,
    $languageCode: LanguageCode!
  )
  @inContext(
    country: $countryCode,
    language: $languageCode
  ) {
    metaobjects(type: "mega_menus" first: 100) {
      edges {
        node {
            handle
          fields {
            type
            key
            value
            references(first: 100) {
              nodes {
                ... on Metaobject {
                  id
                  fields {
                    key
                    value
                    type
                  }
                  handle
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const getMegaMenusBannerMetaobjects = (type) => `
  query (
    $countryCode: CountryCode!,
    $languageCode: LanguageCode!
  )
  @inContext(
    country: $countryCode,
    language: $languageCode
  ) {
    metaobjects(type: "${type}" first: 100) {
      edges {
        node {
          handle
          fields {
            type
            key
            value
            reference {
              ... on MediaImage {
                image {
                  originalSrc
                  altText
                }
              }
              ... on Video {
                id
                sources {
                  url
                  mimeType
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const discountConnectors = (type) => `
  query (
    $countryCode: CountryCode!,
    $languageCode: LanguageCode!
  )
  @inContext(
    country: $countryCode,
    language: $languageCode
  ) {
    metaobjects(type: "${type}" first: 100) {
      edges {
        node {
          handle
          fields {
            type
            key
            value
            reference {
              ... on Product {
                id
                tags
                variants(first: 1) {
                  edges {
                    node {
                      id
                      price {
                        amount
                        currencyCode
                      }
                    }
                  }
                }
              }
            }
            references(first: 250) {
              nodes {
                ... on Product {
                  id
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const shoppingGives = `
  query (
    $countryCode: CountryCode!,
    $languageCode: LanguageCode!
  )
  @inContext(
    country: $countryCode,
    language: $languageCode
  ) {
    metaobjects(type: "shopping_gives" first: 1) {
      edges {
        node {
          handle
          fields {
            type
            key
            value
            reference {
              ... on MediaImage {
                image {
                  originalSrc
                  altText
                }
              }
            }
          }
        }
      }
    }
  }
`;
